// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Id_T","left":"styles_left__3StzK"};